import React, { useMemo, useState } from "react";
import {
  Button,
  Container,
  Divider,
  Drawer,
  IconButton,
  Typography,
} from "@material-ui/core";

import {
  Add,
  Close,
  DeleteOutline,
  Remove,
} from "@material-ui/icons";

import AnnouncementBar from "../components/Header/AnnouncementBar";
import Header from "../components/Header/Header";
import Hero from "../components/Hero/Hero";
import FeatureStrip from "../components/Features/FeatureStrip";
import ProductSection from "../components/Products/ProductSection";
import CampaignBanner from "../components/Campaign/CampaignBanner";
import SaleBanners from "../components/Campaign/SaleBanners";
import Testimonials from "../components/Testimonials/Testimonials";
import Footer from "../components/Footer/Footer";

import ProductCard, {
  Product,
} from "../components/Products/ProductCard";

import { products } from "../data/products";

interface CartItem {
  product: Product;
  quantity: number;
}

const OrganicShop: React.FC = () => {
  const [cart, setCart] = useState<CartItem[]>([]);
  const [cartOpen, setCartOpen] =
    useState(false);

  const addToCart = (product: Product) => {
    setCart((currentCart) => {
      const existing = currentCart.find(
        (item) => item.product.id === product.id
      );

      if (existing) {
        return currentCart.map((item) =>
          item.product.id === product.id
            ? {
                ...item,
                quantity: item.quantity + 1,
              }
            : item
        );
      }

      return [
        ...currentCart,
        {
          product,
          quantity: 1,
        },
      ];
    });

    setCartOpen(true);
  };

  const removeFromCart = (productId: number|string) => {
    setCart((currentCart) =>
      currentCart.filter(
        (item) => item.product.id !== productId
      )
    );
  };

  const updateQuantity = (
    productId: any,
    change: any
  ) => {
    setCart((currentCart) =>
      currentCart
        .map((item) => {
          if (item.product.id !== productId) {
            return item;
          }

          return {
            ...item,
            quantity: Math.max(
              1,
              item.quantity + change
            ),
          };
        })
    );
  };

  const cartCount = useMemo(
    () =>
      cart.reduce(
        (total, item) => total + item.quantity,
        0
      ),
    [cart]
  );

  const cartTotal = useMemo(
    () =>
      cart.reduce(
        (total, item) =>
          total +
          item.product.price * item.quantity,
        0
      ),
    [cart]
  );

  return (
    <div className="page">
      {/* <AnnouncementBar /> */}

      <Header
        cartCount={cartCount}
        onCartClick={() => setCartOpen(true)}
      />

      <Hero />

      <FeatureStrip />

      <ProductSection
        eyebrow="Recently Added Our Store"
        title="New Products"
        products={products}
        onAddToCart={addToCart}
      />

      <CampaignBanner
        image="https://images.unsplash.com/photo-1604187351574-c75ca79f5807?auto=format&fit=crop&w=1800&q=80"
        discount="%15"
        title="Join To #No_plastic Campaign And Get a Discount"
        description="Our comprehensive experience is the key to give our Clients best services."
        buttonText="JOIN NOW"

        sideImage="https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=900&q=90"
        sideDiscount="%30"
        sideSubtitle="Save Up to Flate"
        sideTitle="Fresh Fruit"
        sideButtonText="SHOP NOW"
      />

      <div className="deals-section">
  <Container maxWidth="lg">

    {/* =========================================
        DEALS HEADING
    ========================================= */}

    <div className="deal-heading">

      <Typography className="deal-eyebrow">
        100% Natural
      </Typography>

      <Typography className="deal-section-title">
        Today's Best Deals
      </Typography>

    </div>

    {/* =========================================
        DEALS CONTENT
    ========================================= */}

    <div className="deals-layout">

      {/* LARGE DEAL */}
      <div
        className="deal-banner"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1509676869002-9a9f5b8c1b05?auto=format&fit=crop&w=1200&q=90)",
        }}
      >

        <div className="deal-banner-overlay" />

        <div className="deal-banner-content">

          <Typography className="deal-percent">
            %30
          </Typography>

          <Typography className="deal-title">
            Save Upto 30% Flate
          </Typography>

          <Typography className="deal-subtitle">
            Super Deal
          </Typography>

          <Button className="deal-button">
            SHOP NOW
          </Button>

        </div>

      </div>

      {/* PRODUCT 1 */}
      {products[0] && (
        <div className="deal-product">
          <ProductCard
            product={products[0]}
            onAddToCart={addToCart}
          />
        </div>
      )}

      {/* PRODUCT 2 */}
      {products[1] && (
        <div className="deal-product">
          <ProductCard
            product={products[1]}
            onAddToCart={addToCart}
          />
        </div>
      )}

    </div>

  </Container>
</div>

      <ProductSection
        eyebrow="From Our Shop"
        title="Featured Products"
        products={products.slice(0, 6)}
        onAddToCart={addToCart}
      />

      <div className="sale-section">
        <SaleBanners />
      </div>

      <Testimonials />

      <Footer />

      <Drawer
        anchor="right"
        open={cartOpen}
        onClose={() => setCartOpen(false)}
      >
        <div className="cart-drawer">
          <div className="cart-header">
            <Typography className="cart-title">
              Shopping Basket
            </Typography>

            <IconButton
              onClick={() => setCartOpen(false)}
            >
              <Close />
            </IconButton>
          </div>

          <Divider />

          {cart.length === 0 ? (
            <div className="empty-cart">
              <Typography>
                Cart is empty
              </Typography>
            </div>
          ) : (
            <>
              <div className="cart-items">
                {cart.map((item) => (
                  <div
                    className="cart-item"
                    key={item.product.id}
                  >
                    <img
                      src={item.product.image}
                      alt={item.product.name}
                    />

                    <div className="cart-item-content">
                      <Typography>
                        {item.product.name}
                      </Typography>

                      <Typography className="cart-item-price">
                        $
                        {item.product.price.toFixed(
                          2
                        )}
                      </Typography>

                      <div className="quantity-control">
                        <IconButton
                          size="small"
                          onClick={() =>
                            updateQuantity(
                              item.product.id,
                              -1
                            )
                          }
                        >
                          <Remove />
                        </IconButton>

                        <Typography>
                          {item.quantity}
                        </Typography>

                        <IconButton
                          size="small"
                          onClick={() =>
                            updateQuantity(
                              item.product.id,
                              1
                            )
                          }
                        >
                          <Add />
                        </IconButton>

                        <IconButton
                          size="small"
                          onClick={() =>
                            removeFromCart(
                              item.product.id
                            )
                          }
                        >
                          <DeleteOutline />
                        </IconButton>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="cart-footer">
                <div className="cart-total">
                  <Typography>
                    Total
                  </Typography>

                  <Typography>
                    ${cartTotal.toFixed(2)}
                  </Typography>
                </div>

                <Button
                  fullWidth
                  variant="contained"
                  className="checkout-button"
                >
                  Checkout
                </Button>
              </div>
            </>
          )}
        </div>
      </Drawer>
    </div>
  );
};

export default OrganicShop;